import { TCategory } from 'app/_components/ContentfulPage/ConfigurableList/CategoryCollection'
import { TProductTileData } from 'app/(main)/(catalog)/category/[slug]/_components/ProductTile/ProductTile.types'
import {
  getProductListFromCategory,
  productDataToProductTile,
} from 'app/(main)/(catalog)/category/[slug]/_utils'
import { getLocale } from '@utils/contentful'
import { PageDataServiceFactory } from 'app/_services/CMS'

export async function getCategoryCollection({
  contentfulSlug,
  categories,
  preview,
}) {
  const pageDataService = PageDataServiceFactory.createService()
  const categoryCollectionFromContentful =
    await pageDataService.getEntriesWithFetch({
      contentType: 'genericReferenceBlock',
      query: `fields.slug=${contentfulSlug}`,
      include: 5,
    })
  const categoryCollection: TCategory[] = []

  for (const categoryPageEntry of categoryCollectionFromContentful?.items?.[0]
    .fields?.primaryReferences) {
    const productListWithBCData = await getProductListFromCategory({
      categoryPageEntries: categoryPageEntry,
      categories: categories,
    })

    const productListMappedToProductTileData: TProductTileData[] =
      productListWithBCData?.map((product) => productDataToProductTile(product))

    categoryCollection.push({
      categoryName: categoryPageEntry?.fields?.pageTitleCardTitle,
      productsInCategory: productListMappedToProductTileData,
    })
  }
  return categoryCollection
}
